import { strategistEpic as epic } from "./epic";
import { strategistReducer as reducer } from "./reducer";

export const strategistEpic = epic
export const strategistReducer = reducer
